import { Box, Button, Collapse, IconButton, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core'
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons'
import jsPDF from 'jspdf'
import React, { useState, useMemo } from 'react'
import { useRecoilValue } from 'recoil'
import { mitraFont } from '../../assets/fonts/Mitra/Mitra'
import { titrFont } from '../../assets/fonts/Titr/Titr'
import { vazirFont } from '../../assets/fonts/vazir-font-v18.0.0/Vazir'
import { gregorianToJalali, thousandsSeparate, toFarsiDigits } from '../../assets/utils'
import { useReportFilter, ReportToolbar } from '../../assets/reportFilters'
import { exportExcel, reportMetaNotes, fetchReportQr } from '../../assets/excelUtils'
import { depositsState } from '../../pages/contractor/atoms'
import { userInfoState } from '../../recoil/atoms'
import ResponsiveTable from '../contracts/ResponsiveTable'
import { LoadMoreButton, useIncrementalList } from '../../hooks/useIncrementalList'
import { addPdfFooter } from '../../assets/reportFooter'

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
})


const print = async (contract, userInfo, deposits) => {
    const qrData = contract && contract.id ? await fetchReportQr(contract.id) : null
    // const document_cheque_data = (await axios.get(`contracts/documents/document_cheque/${id}/`)).data
    // const document_transfer_data = (await axios.get(`contracts/documents/document_transfer/${id}/`)).data[0]
    // await axios.put(`contracts/documents/document_transfer/print/${document_transfer_data.id}/`)

    const doc = new jsPDF()
    doc.addFileToVFS("Vazir.ttf", vazirFont);
    doc.addFont("Vazir.ttf", "Vazir", "normal");
    doc.addFileToVFS("Titr.ttf", titrFont);
    doc.addFont("Titr.ttf", "Titr", "normal");
    doc.addFileToVFS("Mitra.ttf", mitraFont);
    doc.addFont("Mitra.ttf", "Mitra", "normal");

    doc.setFont('Titr')
    doc.setFontSize(15)

    const textHeight = doc.getTextDimensions('ب').h
    let currentHeight = 5 * textHeight
    const title = contract.contractee
    doc.text(title, doc.internal.pageSize.width / 2, currentHeight, 'center')
    currentHeight += textHeight

    doc.setFontSize(12)
    doc.text('سپرده', doc.internal.pageSize.width / 2, currentHeight, 'center')
    currentHeight += 2 * textHeight

    doc.setFont('Mitra')
    doc.setFontSize(12)
    const contractorName = userInfo.name
    doc.text(contractorName, 200, currentHeight, 'right')
    currentHeight += textHeight

    let contractTitle = 'قرارداد:  '
    contractTitle += 'شماره  ' + toFarsiDigits(contract.number)
    contractTitle += '  تاریخ  ' + gregorianToJalali(contract.date)
    doc.text(contractTitle, 200, currentHeight, 'right')
    currentHeight += textHeight

    const subject = toFarsiDigits(contract.subject)
    doc.text(subject, 200, currentHeight, 'right')
    currentHeight += textHeight

    // تاریخ گزارش + یادداشت کیوآرکد + خودِ کیوآرکد
    doc.setFont('Mitra')
    doc.setFontSize(9)
    doc.text('تاریخ گزارش: ' + gregorianToJalali(new Date().toISOString().slice(0, 10)), 200, currentHeight, 'right')
    currentHeight += textHeight * 0.9
    if (qrData) {
        doc.text('با اسکن کیوآرکد، این گزارش تا 30 روز در موبایل قابل مشاهده است.', 200, currentHeight, 'right')
        currentHeight += textHeight * 0.9
        try { doc.addImage(qrData, 'PNG', 14, 8, 22, 22) } catch (e) { /* درج QR اختیاری */ }
    }

    let body = []

    for (let depositIndex = 0; depositIndex < deposits.length; depositIndex++) {
        const deposit = deposits[depositIndex]
        let remaining = deposit.amount
        // Make a modifiable copy of the deposit.detail
        const details = deposit.detail.map(detail => ({ ...detail }))

        // If there are no details, add a dummy detail
        if (details.length === 0) {
            details.push({
                amount: 0,
                document_number: '',
                document_date: ''
            })
        }
        for (let detailIndex = 0; detailIndex < details.length; detailIndex++) {
            const detail = details[detailIndex]
            remaining -= detail.amount
            body.push([
                body.length + 1,
                detailIndex === 0 ? deposit.number : '',
                detailIndex === 0 ? deposit.year : '',
                detailIndex === 0 ? deposit.row : '',
                detailIndex === 0 ? deposit.subject : '',
                detailIndex === 0 ? deposit.document_number : '',
                detailIndex === 0 ? gregorianToJalali(deposit.document_date) : '',
                detailIndex === 0 ? thousandsSeparate(deposit.amount) : '',
                thousandsSeparate(detail.amount),
                thousandsSeparate(remaining),
                detail.document_number,
                gregorianToJalali(detail.document_date),
            ].reverse())
        }
    }

    doc.autoTable({
        styles: { font: "Mitra", halign: 'center', valign: 'middle', lineWidth: 0.5, lineColor: 0 },
        head: [[
            'ردیف',
            'شماره بستانکاری',
            'سال',
            'ردیف سپرده',
            'نوع سپرده',
            'شماره سند وصول سپرده',
            'تاریخ سند وصول سپرده',
            'مبلغ سپرده',
            'مبلغ استرداد',
            'مانده استرداد نشده',
            'شماره سند استرداد',
            'تاریخ سند استرداد',
        ].reverse()],
        body: body,
        margin: { top: currentHeight, left: 10, right: 10 },
        theme: 'grid',
        headStyles: { font: 'Mitra', fontSize: 10, halign: 'center', fillColor: 255, textColor: 0, fontStyle: 'normal' },
        bodyStyles: { font: 'Mitra', fontSize: 10, halign: 'center', fillColor: 255, textColor: 0, fontStyle: 'normal' },
    })
    currentHeight = doc.autoTable.previous.finalY + textHeight



    doc.setFont('Titr')
    doc.setFontSize(12)
    addPdfFooter(doc)
    doc.output('dataurlnewwindow', 'details.pdf')
}









// خروجی اکسل سپردهها — همان ستونهای PDF با اعداد واقعی
const exportDepositsExcel = async (contract, deposits) => {
    const qr = contract && contract.id ? await fetchReportQr(contract.id) : null
    const headers = [
        'ردیف',
        'شماره بستانکاری',
        'سال',
        'ردیف سپرده',
        'نوع سپرده',
        'شماره سند وصول سپرده',
        'تاریخ سند وصول سپرده',
        'مبلغ سپرده',
        'مبلغ استرداد',
        'مانده استرداد نشده',
        'شماره سند استرداد',
        'تاریخ سند استرداد',
    ]
    const rows = []
    for (const deposit of deposits) {
        let remaining = deposit.amount
        const details = deposit.detail.map(detail => ({ ...detail }))
        if (details.length === 0) {
            details.push({ amount: 0, document_number: '', document_date: '' })
        }
        for (let i = 0; i < details.length; i++) {
            const detail = details[i]
            remaining -= detail.amount
            rows.push([
                rows.length + 1,
                i === 0 ? deposit.number : '',
                i === 0 ? deposit.year : '',
                i === 0 ? deposit.row : '',
                i === 0 ? deposit.subject : '',
                i === 0 ? deposit.document_number : '',
                i === 0 ? gregorianToJalali(deposit.document_date) : '',
                i === 0 ? deposit.amount : '',
                detail.amount,
                remaining,
                detail.document_number,
                gregorianToJalali(detail.document_date),
            ])
        }
    }
    exportExcel({
        filename: 'deposits.xlsx',
        title: `سپرده‌ها — ${contract.contractee || ''} | قرارداد ${contract.number || ''}`,
        headers,
        rows,
        notes: reportMetaNotes(),
        qrDataUri: qr,
        totalRow: (() => {
            const tr = headers.map(() => '')
            tr[0] = 'جمع'
            tr[7] = deposits.reduce((a, d) => a + (Number(d.amount) || 0), 0)
            tr[8] = deposits.reduce((a, d) => a + (d.detail || []).reduce((x, dt) => x + (Number(dt.amount) || 0), 0), 0)
            // مانده نهایی: جمع سپرده − جمع استرداد
            const dep = deposits.reduce((a, d) => a + (Number(d.amount) || 0), 0)
            const ret = deposits.reduce((a, d) => a + (d.detail || []).reduce((x, dt) => x + (Number(dt.amount) || 0), 0), 0)
            tr[9] = dep - ret
            return tr
        })(),
    })
}

/** جدولِ جزئیاتِ چک‌های استرداد (زیرِ ردیفِ سپرده) */
const DetailTable = ({ detail }) => {
    const rows = [...detail].sort((a, b) => {
        return new Date(b.cheque_date) - new Date(a.cheque_date)
    })
    return (
        <Table size='small'>
            <TableHead>
                <TableRow>
                    <TableCell align='center'><strong>ردیف</strong></TableCell>
                    <TableCell align='center'><strong>شماره چک</strong></TableCell>
                    <TableCell align='center'><strong>تاریخ چک</strong></TableCell>
                    <TableCell align='center'><strong>مبلغ</strong></TableCell>
                    <TableCell align='center'><strong>صورت وضعیت</strong></TableCell>
                    <TableCell align='center'><strong>توضیح</strong></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {rows.map((row, index) => (
                    <TableRow key={row.id}>
                        <TableCell align='center' component='th'><strong>{toFarsiDigits(index + 1)}</strong></TableCell>
                        <TableCell align='center'>{toFarsiDigits(row.cheque_number)}</TableCell>
                        <TableCell align='center'>{gregorianToJalali(row.cheque_date)}</TableCell>
                        <TableCell align='center'>{toFarsiDigits(thousandsSeparate(row.amount))}</TableCell>
                        <TableCell align='center'>-</TableCell>
                        <TableCell align='center'>-</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    )
}

const Deposits = props => {
    const deposits = useRecoilValue(depositsState)
    const userInfo = useRecoilValue(userInfoState)
    const [expandedId, setExpandedId] = useState(null)

    // فیلتر جستجو + سال مالی (بر اساس تاریخ سند بستانکاری سپرده)
    const extract = useMemo(() => ({
        year: (d) => {
            const j = d.document_date || (d.detail && d.detail[0] && d.detail[0].document_date)
            const jj = j ? gregorianToJalali(j) : null
            return jj ? String(jj).split('/')[0] : null
        },
        search: (d) => [
            d.subject, d.amount, d.document_number, d.document_date,
            ...(d.detail || []).map((x) => [x.document_number, x.amount, x.cheque_number]),
        ],
    }), [])
    const { search, setSearch, year, setYear, years, filtered } = useReportFilter(deposits, extract)

    // رندرِ تدریجی — یک قرارداد می‌تواند تا ۹٬۷۱۷ سپرده داشته باشد
    const { visible, hasMore, loadMore, remaining } = useIncrementalList(filtered, {
        step: 50,
        resetKey: `${search}|${year}`,
    })

    const columns = useMemo(() => [
        {
            key: 'expand', label: '', width: 44,
            render: (d) => (
                <IconButton
                    disabled={!d.detail || d.detail.length === 0}
                    size='small'
                    onClick={() => setExpandedId(expandedId === d.id ? null : d.id)}
                >
                    {expandedId === d.id ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                </IconButton>
            ),
        },
        { key: 'number', label: 'شماره بستانکاری', primary: true, render: (d) => toFarsiDigits(d.number) },
        { key: 'year', label: 'سال', render: (d) => toFarsiDigits(d.year) },
        { key: 'row', label: 'ردیف سپرده', render: (d) => toFarsiDigits(d.row) },
        { key: 'amount', label: 'مبلغ سپرده', render: (d) => toFarsiDigits(thousandsSeparate(d.amount)) },
        { key: 'refund_amount', label: 'جمع استرداد شده', render: (d) => toFarsiDigits(thousandsSeparate(d.refund_amount)) },
        {
            key: 'balance', label: 'مانده',
            render: (d) => toFarsiDigits(thousandsSeparate(d.amount - d.refund_amount)),
        },
    ], [expandedId])
    return (
        <>
            <ReportToolbar search={search} setSearch={setSearch} year={year} setYear={setYear} years={years} />
            <Button
                variant='contained'
                color='primary'
                style={{ marginRight: 10 }}
                onClick={() => { print(props.contract, userInfo, deposits) }}
            >
                چاپ
            </Button>

            <Button
                variant='contained'
                color='secondary'
                onClick={() => { exportDepositsExcel(props.contract, filtered) }}
            >
                دانلود اکسل
            </Button>

            <Box style={{ marginTop: '20px' }}>
                <ResponsiveTable
                    columns={columns}
                    rows={visible}
                    showIndex
                    indexLabel="ردیف"
                    maxHeight={450}
                    emptyText="سپرده‌ای یافت نشد."
                    expandedKey={expandedId}
                    renderExpanded={(d) => (d.detail && d.detail.length ? <DetailTable detail={d.detail} /> : null)}
                />
                <LoadMoreButton hasMore={hasMore} remaining={remaining} onClick={loadMore} />
            </Box>
        </>
    )
}
export default Deposits